export const END_CUSTOMER = 'END_CUSTOMER';
export const VAR = 'VAR';
export const ACCOUNT_MANAGER = 'CALIX_EMPLOYEE';
